import cx from 'classnames'
import { ProcessedEvent } from '../../types'
import styles from './DayColumn.module.css'
import { DayColumnEvents } from './DayColumnEvents'
import { DayColumnAddEvent } from './DayColumnAddEvent'

export function DayColumn({
  date,
  events,
  isToday = false,
}: {
  date: Date
  events: ProcessedEvent[]
  isToday?: boolean
}) {
  return (
    <div
      className={cx(styles.DayColumn, {
        [styles.isToday]: isToday,
      })}
    >
      <DayColumnAddEvent today={date} />
      <DayColumnEvents todayEvents={events} />
    </div>
  )
}
